export default __webpack_public_path__ + "static/media/bag.73321849.svg";